import { ISector } from 'src/app/core/models/i-sector';

export const ALL_SECTORS_SELECTED: ISector = {
  id: -1,
  name: 'All Sectors selected',
  derived: false,
};

export const NO_SECTORS_SELECTED: ISector = {
  id: -2,
  name: 'No Sector selected',
  derived: false,
};
